import { render, staticRenderFns } from "./videoModal.vue?vue&type=template&id=6a22e45c&"
import script from "./videoModal.vue?vue&type=script&lang=ts&"
export * from "./videoModal.vue?vue&type=script&lang=ts&"
import style0 from "./videoModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports